interface BrandProps {
  compact?: boolean;
  inverse?: boolean;
}

export function Brand({ compact = false, inverse = false }: BrandProps) {
  return (
    <a className={`brand ${compact ? 'brand--compact' : ''} ${inverse ? 'brand--inverse' : ''}`} href="/" aria-label="ThisBotDoesMySocialMedia home">
      <img src="/brand/logo-primary.png" alt="" />
      <span className="brand__type">
        <strong>ThisBot</strong>
        {!compact && <span>DoesMySocialMedia</span>}
      </span>
    </a>
  );
}
